// removed by extract-text-webpack-plugin
module.exports = {"imageWrapper":"_1ty9-uB6uU2Y4sAU31_a_5","-theme-rounded-corners":"_2elgrrzz-q8yhvd7aYtTz","image":"_2beiEX6j8jhvwvxUNM1g3N","-theme-full":"_34C0s_8iuMhM8162pmjfO7","-theme-fixed":"_3cj1k8ZENQvoOrH5dSCQi7","gradient":"_3UFEMHX08hPmtDeXLaTjgN","-gradient-section":"_2cl-fo5RdAS2ZLrfvG2qZh","-gradient-feature":"H4ZrRxypBAvogoMNYx4B"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FancyImage/FancyImage.module.scss
// module id = 755
// module chunks = 0